module.exports = __webpack_public_path__ + "img/guide-student1.03e47dbd.png";